// Generated by pnpm agent:tools from locally maintained provider definitions.
export default {
  "dataforseo_keyword_ideas": {
    "data": {
      "type": "json",
      "description": "Keyword measurements; unavailable values remain null"
    }
  },
  "dataforseo_search_volumes": {
    "data": {
      "type": "json",
      "description": "Keyword measurements; unavailable values remain null"
    }
  },
  "dingtalk_read_document": {
    "blocks": {
      "type": "json",
      "description": "Document blocks"
    }
  },
  "dingtalk_read_table": {
    "rows": {
      "type": "json",
      "description": "Cell values"
    },
    "content": {
      "type": "string",
      "description": "Tab-separated table text"
    }
  },
  "dingtalk_send_message": {
    "processQueryKey": {
      "type": "string",
      "description": "Provider message tracking key"
    }
  },
  "exa_agent": {
    "runId": {
      "type": "string",
      "description": "Identifier of the agent run, reusable as previousRunId"
    },
    "status": {
      "type": "string",
      "description": "Final status of the agent run"
    },
    "stopReason": {
      "type": "string",
      "description": "Why the agent stopped, such as schema_satisfied",
      "nullable": true
    },
    "text": {
      "type": "string",
      "description": "The written answer produced by the agent"
    },
    "structured": {
      "type": "json",
      "description": "Structured result matching outputSchema, when one was supplied",
      "optional": true
    },
    "grounding": {
      "type": "json",
      "description": "Field-level citations backing the agent output",
      "optional": true
    },
    "research": {
      "type": "array",
      "description": "The agent answer in the shape the retired Research operation emitted, so workflows that reference it keep resolving",
      "items": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "url": {
            "type": "string"
          },
          "summary": {
            "type": "string"
          },
          "text": {
            "type": "string"
          },
          "score": {
            "type": "number"
          }
        }
      }
    }
  },
  "exa_answer": {
    "answer": {
      "type": "json",
      "description": "AI-generated answer to the question. A string, or an object matching outputSchema when one was supplied."
    },
    "citations": {
      "type": "array",
      "description": "Sources and citations for the answer",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "the tool identifier for the cited source"
          },
          "title": {
            "type": "string",
            "description": "The title of the cited source"
          },
          "url": {
            "type": "string",
            "description": "The URL of the cited source"
          },
          "text": {
            "type": "string",
            "description": "Full page text of the cited source, when text is enabled"
          },
          "author": {
            "type": "string",
            "description": "The author of the cited source"
          },
          "publishedDate": {
            "type": "string",
            "description": "Publication date of the cited source"
          }
        }
      }
    },
    "requestId": {
      "type": "string",
      "description": "the tool request identifier, useful for support"
    }
  },
  "exa_find_similar_links": {
    "similarLinks": {
      "type": "array",
      "description": "Similar links found with titles, URLs, and text snippets",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "the tool identifier for the similar page"
          },
          "title": {
            "type": "string",
            "description": "The title of the similar webpage"
          },
          "url": {
            "type": "string",
            "description": "The URL of the similar webpage"
          },
          "text": {
            "type": "string",
            "description": "Text snippet or full content from the similar webpage"
          },
          "summary": {
            "type": "string",
            "description": "AI-generated summary of the similar webpage"
          },
          "highlights": {
            "type": "array",
            "description": "Relevant snippets extracted from the page",
            "items": {
              "type": "string"
            }
          },
          "score": {
            "type": "number",
            "description": "Similarity score indicating how similar the page is"
          }
        }
      }
    },
    "requestId": {
      "type": "string",
      "description": "the tool request identifier, useful for support"
    }
  },
  "exa_get_contents": {
    "results": {
      "type": "array",
      "description": "Retrieved content from URLs with title, text, and summaries",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "the tool identifier for the retrieved document"
          },
          "url": {
            "type": "string",
            "description": "The URL that content was retrieved from"
          },
          "title": {
            "type": "string",
            "description": "The title of the webpage"
          },
          "text": {
            "type": "string",
            "description": "The full text content of the webpage"
          },
          "summary": {
            "type": "string",
            "description": "AI-generated summary of the webpage content"
          },
          "highlights": {
            "type": "array",
            "description": "Relevant snippets extracted from the page",
            "items": {
              "type": "string"
            }
          },
          "highlightScores": {
            "type": "array",
            "description": "Similarity score for each highlight",
            "items": {
              "type": "number"
            }
          },
          "subpages": {
            "type": "json",
            "description": "Crawled subpages of the document"
          },
          "entities": {
            "type": "json",
            "description": "Structured entity data for company, people, and publication pages"
          },
          "extras": {
            "type": "json",
            "description": "Extracted links and image links when requested"
          }
        }
      }
    },
    "statuses": {
      "type": "json",
      "description": "Per-URL crawl outcome, showing which pages succeeded and whether they came from cache"
    },
    "requestId": {
      "type": "string",
      "description": "the tool request identifier, useful for support"
    }
  },
  "exa_search": {
    "results": {
      "type": "array",
      "description": "Search results with titles, URLs, and text snippets",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "Result identifier, usable as an id on the Get Contents operation"
          },
          "title": {
            "type": "string",
            "description": "The title of the search result"
          },
          "url": {
            "type": "string",
            "description": "The URL of the search result"
          },
          "publishedDate": {
            "type": "string",
            "description": "Date when the content was published"
          },
          "author": {
            "type": "string",
            "description": "The author of the content"
          },
          "summary": {
            "type": "string",
            "description": "A brief summary of the content"
          },
          "favicon": {
            "type": "string",
            "description": "URL of the site's favicon"
          },
          "image": {
            "type": "string",
            "description": "URL of a representative image from the page"
          },
          "text": {
            "type": "string",
            "description": "Text snippet or full content from the page"
          },
          "highlights": {
            "type": "array",
            "description": "Relevant snippets extracted from the page",
            "items": {
              "type": "string"
            }
          },
          "highlightScores": {
            "type": "array",
            "description": "Similarity score for each highlight",
            "items": {
              "type": "number"
            }
          },
          "subpages": {
            "type": "json",
            "description": "Crawled subpages of the result"
          },
          "entities": {
            "type": "json",
            "description": "Structured entity data for company, people, and publication results"
          },
          "extras": {
            "type": "json",
            "description": "Extracted links and image links when requested"
          },
          "score": {
            "type": "number",
            "description": "Relevance score. Only returned by the legacy neural search type",
            "optional": true
          }
        }
      }
    },
    "requestId": {
      "type": "string",
      "description": "the tool request identifier, useful for support"
    },
    "structuredOutput": {
      "type": "json",
      "description": "Synthesized answer matching outputSchema, when one was supplied",
      "optional": true
    },
    "grounding": {
      "type": "json",
      "description": "Field-level citations backing the synthesized output",
      "optional": true
    }
  },
  "feishu_read_document": {
    "content": {
      "type": "string",
      "description": "Document plain text"
    }
  },
  "feishu_send_message": {
    "messageId": {
      "type": "string",
      "description": "Provider message ID"
    }
  },
  "firecrawl_agent": {
    "success": {
      "type": "boolean",
      "description": "Whether the agent operation was successful"
    },
    "status": {
      "type": "string",
      "description": "Current status of the agent job (processing, completed, failed)"
    },
    "data": {
      "type": "object",
      "description": "Extracted data from the agent"
    },
    "expiresAt": {
      "type": "string",
      "description": "Timestamp when the results expire (24 hours)"
    },
    "sources": {
      "type": "object",
      "description": "Array of source URLs used by the agent"
    }
  },
  "firecrawl_batch_scrape_status": {
    "status": {
      "type": "string",
      "description": "Current batch scrape status (scraping, completed, or failed)"
    },
    "total": {
      "type": "number",
      "description": "Total number of pages attempted"
    },
    "completed": {
      "type": "number",
      "description": "Number of pages successfully scraped"
    },
    "creditsUsed": {
      "type": "number",
      "description": "Credits consumed by the batch scrape"
    },
    "expiresAt": {
      "type": "string",
      "description": "ISO timestamp when the batch scrape results expire",
      "optional": true
    },
    "next": {
      "type": "string",
      "description": "URL to retrieve the next page of results when present",
      "optional": true
    },
    "pages": {
      "type": "array",
      "description": "Array of scraped pages with their content and metadata",
      "items": {
        "type": "object",
        "properties": {
          "markdown": {
            "type": "string",
            "description": "Page content in markdown format"
          },
          "html": {
            "type": "string",
            "description": "Processed HTML content of the page",
            "optional": true
          },
          "rawHtml": {
            "type": "string",
            "description": "Unprocessed raw HTML content",
            "optional": true
          },
          "links": {
            "type": "array",
            "description": "Array of links found on the page",
            "optional": true,
            "items": {
              "type": "string",
              "description": "URL found on the page"
            }
          },
          "screenshot": {
            "type": "string",
            "description": "Screenshot URL (expires after 24 hours)",
            "optional": true
          },
          "metadata": {
            "type": "object",
            "description": "Page metadata from crawl operation",
            "properties": {
              "title": {
                "type": "string",
                "description": "Page title"
              },
              "description": {
                "type": "string",
                "description": "Page meta description",
                "optional": true
              },
              "language": {
                "type": "string",
                "description": "Page language code",
                "optional": true
              },
              "sourceURL": {
                "type": "string",
                "description": "Original source URL"
              },
              "statusCode": {
                "type": "number",
                "description": "HTTP status code"
              },
              "ogLocaleAlternate": {
                "type": "array",
                "description": "Alternate locale versions",
                "optional": true,
                "items": {
                  "type": "string",
                  "description": "Locale code"
                }
              }
            }
          }
        }
      }
    }
  },
  "firecrawl_parse": {
    "markdown": {
      "type": "string",
      "description": "Parsed document content in markdown format"
    },
    "summary": {
      "type": "string",
      "description": "Generated summary of the document",
      "optional": true
    },
    "html": {
      "type": "string",
      "description": "Processed HTML content",
      "optional": true
    },
    "rawHtml": {
      "type": "string",
      "description": "Unprocessed raw HTML content",
      "optional": true
    },
    "screenshot": {
      "type": "string",
      "description": "Screenshot URL or base64 (when requested)",
      "optional": true
    },
    "links": {
      "type": "array",
      "description": "URLs discovered in the document",
      "optional": true,
      "items": {
        "type": "string",
        "description": "Discovered URL"
      }
    },
    "metadata": {
      "type": "object",
      "description": "Document metadata",
      "optional": true,
      "properties": {
        "title": {
          "type": "string",
          "description": "Document title",
          "optional": true
        },
        "description": {
          "type": "string",
          "description": "Document description",
          "optional": true
        },
        "language": {
          "type": "string",
          "description": "Document language code",
          "optional": true
        },
        "sourceURL": {
          "type": "string",
          "description": "Source URL",
          "optional": true
        },
        "url": {
          "type": "string",
          "description": "Final URL",
          "optional": true
        },
        "keywords": {
          "type": "string",
          "description": "Document keywords",
          "optional": true
        },
        "statusCode": {
          "type": "number",
          "description": "HTTP status code",
          "optional": true
        },
        "contentType": {
          "type": "string",
          "description": "Document content type",
          "optional": true
        },
        "error": {
          "type": "string",
          "description": "Error message if parse failed",
          "optional": true
        }
      }
    },
    "warning": {
      "type": "string",
      "description": "Warning message from the parse operation",
      "optional": true
    }
  },
  "firecrawl_scrape": {
    "markdown": {
      "type": "string",
      "description": "Page content in markdown format"
    },
    "html": {
      "type": "string",
      "description": "Raw HTML content of the page",
      "optional": true
    },
    "metadata": {
      "type": "object",
      "description": "Page metadata including SEO and Open Graph information",
      "properties": {
        "title": {
          "type": "string",
          "description": "Page title"
        },
        "description": {
          "type": "string",
          "description": "Page meta description",
          "optional": true
        },
        "language": {
          "type": "string",
          "description": "Page language code (e.g., \"en\")",
          "optional": true
        },
        "sourceURL": {
          "type": "string",
          "description": "Original source URL that was scraped"
        },
        "statusCode": {
          "type": "number",
          "description": "HTTP status code of the response"
        },
        "keywords": {
          "type": "string",
          "description": "Page meta keywords",
          "optional": true
        },
        "robots": {
          "type": "string",
          "description": "Robots meta directive (e.g., \"follow, index\")",
          "optional": true
        },
        "ogTitle": {
          "type": "string",
          "description": "Open Graph title",
          "optional": true
        },
        "ogDescription": {
          "type": "string",
          "description": "Open Graph description",
          "optional": true
        },
        "ogUrl": {
          "type": "string",
          "description": "Open Graph URL",
          "optional": true
        },
        "ogImage": {
          "type": "string",
          "description": "Open Graph image URL",
          "optional": true
        },
        "ogLocaleAlternate": {
          "type": "array",
          "description": "Alternate locale versions for Open Graph",
          "optional": true,
          "items": {
            "type": "string",
            "description": "Locale code"
          }
        },
        "ogSiteName": {
          "type": "string",
          "description": "Open Graph site name",
          "optional": true
        },
        "error": {
          "type": "string",
          "description": "Error message if scrape failed",
          "optional": true
        }
      }
    }
  },
  "firecrawl_search": {
    "data": {
      "type": "array",
      "description": "Search results data with scraped content and metadata",
      "items": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string",
            "description": "Search result title from search engine"
          },
          "description": {
            "type": "string",
            "description": "Search result description/snippet from search engine"
          },
          "url": {
            "type": "string",
            "description": "URL of the search result"
          },
          "markdown": {
            "type": "string",
            "description": "Page content in markdown; returned only when scraping was requested via the hidden scrapeOptions input",
            "optional": true
          },
          "html": {
            "type": "string",
            "description": "Processed HTML content; returned only when \"html\" is among the scrape formats requested via the hidden scrapeOptions input",
            "optional": true
          },
          "rawHtml": {
            "type": "string",
            "description": "Unprocessed raw HTML; returned only when \"rawHtml\" is among the scrape formats requested via the hidden scrapeOptions input",
            "optional": true
          },
          "links": {
            "type": "array",
            "description": "Links found on the page; returned only when \"links\" is among the scrape formats requested via the hidden scrapeOptions input",
            "optional": true,
            "items": {
              "type": "string",
              "description": "URL found on the page"
            }
          },
          "screenshot": {
            "type": "string",
            "description": "Screenshot URL (expires after 24 hours); returned only when \"screenshot\" is among the scrape formats requested via the hidden scrapeOptions input",
            "optional": true
          },
          "metadata": {
            "type": "object",
            "description": "Metadata about the search result page",
            "properties": {
              "title": {
                "type": "string",
                "description": "Page title",
                "optional": true
              },
              "description": {
                "type": "string",
                "description": "Page meta description",
                "optional": true
              },
              "sourceURL": {
                "type": "string",
                "description": "Original source URL"
              },
              "statusCode": {
                "type": "number",
                "description": "HTTP status code",
                "optional": true
              },
              "error": {
                "type": "string",
                "description": "Error message if scrape failed",
                "optional": true
              }
            }
          }
        }
      }
    }
  },
  "firecrawl_batch_scrape": {
    "pages": {
      "type": "array",
      "description": "Array of scraped pages with their content and metadata",
      "items": {
        "type": "object",
        "properties": {
          "markdown": {
            "type": "string",
            "description": "Page content in markdown format"
          },
          "html": {
            "type": "string",
            "description": "Processed HTML content of the page",
            "optional": true
          },
          "rawHtml": {
            "type": "string",
            "description": "Unprocessed raw HTML content",
            "optional": true
          },
          "links": {
            "type": "array",
            "description": "Array of links found on the page",
            "optional": true,
            "items": {
              "type": "string",
              "description": "URL found on the page"
            }
          },
          "screenshot": {
            "type": "string",
            "description": "Screenshot URL (expires after 24 hours)",
            "optional": true
          },
          "metadata": {
            "type": "object",
            "description": "Page metadata from crawl operation",
            "properties": {
              "title": {
                "type": "string",
                "description": "Page title"
              },
              "description": {
                "type": "string",
                "description": "Page meta description",
                "optional": true
              },
              "language": {
                "type": "string",
                "description": "Page language code",
                "optional": true
              },
              "sourceURL": {
                "type": "string",
                "description": "Original source URL"
              },
              "statusCode": {
                "type": "number",
                "description": "HTTP status code"
              },
              "ogLocaleAlternate": {
                "type": "array",
                "description": "Alternate locale versions",
                "optional": true,
                "items": {
                  "type": "string",
                  "description": "Locale code"
                }
              }
            }
          }
        }
      }
    },
    "total": {
      "type": "number",
      "description": "Total number of pages attempted"
    },
    "completed": {
      "type": "number",
      "description": "Number of pages successfully scraped"
    },
    "invalidURLs": {
      "type": "array",
      "description": "URLs that were skipped because they were invalid",
      "optional": true,
      "items": {
        "type": "string",
        "description": "Invalid URL"
      }
    }
  },
  "firecrawl_cancel_crawl": {
    "status": {
      "type": "string",
      "description": "Status of the cancelled crawl job (e.g., \"cancelled\")"
    }
  },
  "firecrawl_crawl_status": {
    "status": {
      "type": "string",
      "description": "Current crawl status (scraping, completed, or failed)"
    },
    "total": {
      "type": "number",
      "description": "Total number of pages attempted"
    },
    "completed": {
      "type": "number",
      "description": "Number of pages successfully crawled"
    },
    "creditsUsed": {
      "type": "number",
      "description": "Credits consumed by the crawl"
    },
    "expiresAt": {
      "type": "string",
      "description": "ISO timestamp when the crawl results expire",
      "optional": true
    },
    "next": {
      "type": "string",
      "description": "URL to retrieve the next page of results when present",
      "optional": true
    },
    "pages": {
      "type": "array",
      "description": "Array of crawled pages with their content and metadata",
      "items": {
        "type": "object",
        "properties": {
          "markdown": {
            "type": "string",
            "description": "Page content in markdown format"
          },
          "html": {
            "type": "string",
            "description": "Processed HTML content of the page",
            "optional": true
          },
          "rawHtml": {
            "type": "string",
            "description": "Unprocessed raw HTML content",
            "optional": true
          },
          "links": {
            "type": "array",
            "description": "Array of links found on the page",
            "optional": true,
            "items": {
              "type": "string",
              "description": "URL found on the page"
            }
          },
          "screenshot": {
            "type": "string",
            "description": "Screenshot URL (expires after 24 hours)",
            "optional": true
          },
          "metadata": {
            "type": "object",
            "description": "Page metadata from crawl operation",
            "properties": {
              "title": {
                "type": "string",
                "description": "Page title"
              },
              "description": {
                "type": "string",
                "description": "Page meta description",
                "optional": true
              },
              "language": {
                "type": "string",
                "description": "Page language code",
                "optional": true
              },
              "sourceURL": {
                "type": "string",
                "description": "Original source URL"
              },
              "statusCode": {
                "type": "number",
                "description": "HTTP status code"
              },
              "ogLocaleAlternate": {
                "type": "array",
                "description": "Alternate locale versions",
                "optional": true,
                "items": {
                  "type": "string",
                  "description": "Locale code"
                }
              }
            }
          }
        }
      }
    }
  },
  "firecrawl_crawl": {
    "pages": {
      "type": "array",
      "description": "Array of crawled pages with their content and metadata",
      "items": {
        "type": "object",
        "properties": {
          "markdown": {
            "type": "string",
            "description": "Page content in markdown format"
          },
          "html": {
            "type": "string",
            "description": "Processed HTML content of the page",
            "optional": true
          },
          "rawHtml": {
            "type": "string",
            "description": "Unprocessed raw HTML content",
            "optional": true
          },
          "links": {
            "type": "array",
            "description": "Array of links found on the page",
            "optional": true,
            "items": {
              "type": "string",
              "description": "URL found on the page"
            }
          },
          "screenshot": {
            "type": "string",
            "description": "Screenshot URL (expires after 24 hours)",
            "optional": true
          },
          "metadata": {
            "type": "object",
            "description": "Page metadata from crawl operation",
            "properties": {
              "title": {
                "type": "string",
                "description": "Page title"
              },
              "description": {
                "type": "string",
                "description": "Page meta description",
                "optional": true
              },
              "language": {
                "type": "string",
                "description": "Page language code",
                "optional": true
              },
              "sourceURL": {
                "type": "string",
                "description": "Original source URL"
              },
              "statusCode": {
                "type": "number",
                "description": "HTTP status code"
              },
              "ogLocaleAlternate": {
                "type": "array",
                "description": "Alternate locale versions",
                "optional": true,
                "items": {
                  "type": "string",
                  "description": "Locale code"
                }
              }
            }
          }
        }
      }
    },
    "total": {
      "type": "number",
      "description": "Total number of pages found during crawl"
    }
  },
  "firecrawl_credit_usage": {
    "remainingCredits": {
      "type": "number",
      "description": "Number of credits remaining for the team"
    },
    "planCredits": {
      "type": "number",
      "description": "Credits allocated in the current plan",
      "optional": true
    },
    "billingPeriodStart": {
      "type": "string",
      "description": "Start of the current billing period",
      "optional": true
    },
    "billingPeriodEnd": {
      "type": "string",
      "description": "End of the current billing period",
      "optional": true
    }
  },
  "firecrawl_extract_status": {
    "status": {
      "type": "string",
      "description": "Current extract status (processing, completed, failed, or cancelled)"
    },
    "data": {
      "type": "json",
      "description": "Extracted structured data according to the schema or prompt"
    },
    "expiresAt": {
      "type": "string",
      "description": "ISO timestamp when the extract results expire",
      "optional": true
    },
    "creditsUsed": {
      "type": "number",
      "description": "Number of credits used by the extract job",
      "optional": true
    },
    "tokensUsed": {
      "type": "number",
      "description": "Number of tokens used by the extract job",
      "optional": true
    }
  },
  "firecrawl_extract": {
    "success": {
      "type": "boolean",
      "description": "Whether the extraction operation was successful"
    },
    "data": {
      "type": "object",
      "description": "Extracted structured data according to the schema or prompt"
    }
  },
  "firecrawl_map": {
    "success": {
      "type": "boolean",
      "description": "Whether the mapping operation was successful"
    },
    "links": {
      "type": "array",
      "description": "Array of discovered URLs from the website",
      "items": {
        "type": "string"
      }
    }
  },
  "parallel_deep_research": {
    "status": {
      "type": "string",
      "description": "Task status (completed, failed, running)"
    },
    "run_id": {
      "type": "string",
      "description": "Unique ID for this research task"
    },
    "message": {
      "type": "string",
      "description": "Status message"
    },
    "content": {
      "type": "json",
      "description": "Research findings: a markdown report string for the text output format, or a structured object with query-specific keys for the auto format"
    },
    "basis": {
      "type": "array",
      "description": "Citations and sources with reasoning and confidence levels",
      "items": {
        "type": "object",
        "properties": {
          "field": {
            "type": "string",
            "description": "Output field dot-notation path"
          },
          "reasoning": {
            "type": "string",
            "description": "Explanation for the result"
          },
          "citations": {
            "type": "array",
            "description": "Array of sources",
            "items": {
              "type": "object",
              "properties": {
                "url": {
                  "type": "string",
                  "description": "Source URL"
                },
                "title": {
                  "type": "string",
                  "description": "Source title",
                  "optional": true
                },
                "excerpts": {
                  "type": "array",
                  "description": "Relevant excerpts from the source",
                  "items": {
                    "type": "string"
                  },
                  "optional": true
                }
              }
            }
          },
          "confidence": {
            "type": "string",
            "description": "Confidence level (low, medium, high)",
            "optional": true
          }
        }
      }
    }
  },
  "parallel_extract": {
    "extract_id": {
      "type": "string",
      "description": "Unique identifier for this extraction request"
    },
    "results": {
      "type": "array",
      "description": "Extracted information from the provided URLs",
      "items": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string",
            "description": "The source URL"
          },
          "title": {
            "type": "string",
            "description": "The title of the page",
            "optional": true
          },
          "publish_date": {
            "type": "string",
            "description": "Publication date (YYYY-MM-DD)",
            "optional": true
          },
          "excerpts": {
            "type": "array",
            "description": "Relevant text excerpts in markdown",
            "items": {
              "type": "string"
            }
          },
          "full_content": {
            "type": "string",
            "description": "Full page content as markdown (only when requested)",
            "optional": true
          }
        }
      }
    },
    "errors": {
      "type": "array",
      "description": "URLs that could not be extracted, with the reason",
      "items": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string",
            "description": "The URL that failed"
          },
          "error_type": {
            "type": "string",
            "description": "Category of the failure"
          },
          "http_status_code": {
            "type": "number",
            "description": "HTTP status returned by the page, if any",
            "optional": true
          },
          "content": {
            "type": "string",
            "description": "Error detail",
            "optional": true
          }
        }
      }
    }
  },
  "parallel_search": {
    "search_id": {
      "type": "string",
      "description": "Unique identifier for this search request"
    },
    "results": {
      "type": "array",
      "description": "Search results with excerpts from relevant pages",
      "items": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string",
            "description": "The URL of the search result"
          },
          "title": {
            "type": "string",
            "description": "The title of the search result",
            "optional": true
          },
          "publish_date": {
            "type": "string",
            "description": "Publication date of the page (YYYY-MM-DD)",
            "optional": true
          },
          "excerpts": {
            "type": "array",
            "description": "LLM-optimized excerpts from the page",
            "items": {
              "type": "string"
            }
          }
        }
      }
    }
  },
  "serpapi_google_search": {
    "data": {
      "type": "json",
      "description": "Original search results, video metadata or timestamped transcript"
    }
  },
  "serpapi_youtube_video_transcript": {
    "data": {
      "type": "json",
      "description": "Original search results, video metadata or timestamped transcript"
    }
  },
  "serpapi_youtube_data": {
    "data": {
      "type": "json",
      "description": "Original search results, video metadata or timestamped transcript"
    }
  },
  "serper_search": {
    "searchResults": {
      "type": "array",
      "description": "Search results with titles, links, snippets, and type-specific metadata (date for news, rating for places, imageUrl for images, duration/source for videos, price/source for shopping)",
      "items": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string",
            "description": "Result title"
          },
          "link": {
            "type": "string",
            "description": "Result URL"
          },
          "snippet": {
            "type": "string",
            "description": "Result description/snippet",
            "optional": true
          },
          "position": {
            "type": "number",
            "description": "Position in search results"
          },
          "date": {
            "type": "string",
            "description": "Publication date (news/videos)",
            "optional": true
          },
          "imageUrl": {
            "type": "string",
            "description": "Image URL (images/news/shopping)",
            "optional": true
          },
          "source": {
            "type": "string",
            "description": "Source name (news/videos/shopping)",
            "optional": true
          },
          "rating": {
            "type": "number",
            "description": "Rating (places)",
            "optional": true
          },
          "ratingCount": {
            "type": "number",
            "description": "Number of reviews (places)",
            "optional": true
          },
          "address": {
            "type": "string",
            "description": "Address (places)",
            "optional": true
          },
          "price": {
            "type": "string",
            "description": "Price (shopping)",
            "optional": true
          },
          "duration": {
            "type": "string",
            "description": "Duration (videos)",
            "optional": true
          }
        }
      }
    }
  },
  "wecom_read_document": {
    "content": {
      "type": "string",
      "description": "Document plain text"
    },
    "version": {
      "type": "number",
      "description": "Document version"
    }
  },
  "wecom_send_message": {
    "messageId": {
      "type": "string",
      "description": "Provider message ID"
    }
  }
}
